import { IStatusConfig } from '../../../components/StatusBadge'
import { ITabDef } from '../../../helpers/tabErrorUtils'
import { TEmployeeEvent, TEmployeeStatus } from '../../../services/Employee/types'

export const EMPLOYEE_STATUSES: TEmployeeStatus[] = ['pending', 'active', 'inactive']

/** The tab labels of "Colaboradores" and the badge of the sheet. */
export const EMPLOYEE_STATUS: Record<TEmployeeStatus, IStatusConfig & { tab: string }> = {
  pending: { label: 'Pendente', tab: 'Colaboradores Pendentes', colorScheme: 'yellow' },
  active: { label: 'Ativo', tab: 'Colaboradores Ativos', colorScheme: 'green' },
  inactive: { label: 'Inativo', tab: 'Colaboradores Inativos', colorScheme: 'gray' }
}

/** The admission card's badge: none while pending (P13 keeps everyone in "Pré Boarding"). */
export const ADMISSION_CARD_BADGE: Partial<Record<TEmployeeStatus, IStatusConfig>> = {
  active: { label: 'Aprovado', colorScheme: 'green' },
  inactive: { label: 'Inativo', colorScheme: 'gray' }
}

export const HISTORY_EVENT_LABELS: Record<TEmployeeEvent, string> = {
  submitted: 'Admissão enviada pelo formulário',
  created: 'Cadastrado direto pelo RH',
  approved: 'Aprovado',
  inactivated: 'Inativado',
  reactivated: 'Reativado',
  legacy_linked: 'Registros legados vinculados'
}

/** Which date an event informed, to say it next to the event. */
export const HISTORY_DATE_LABELS: Partial<Record<TEmployeeEvent, string>> = {
  created: 'Admissão',
  approved: 'Admissão',
  reactivated: 'Admissão',
  inactivated: 'Desligamento'
}

export const MAGENTA_LABELS = { acelera: 'Acelera', brilha: 'Brilha', conexao: 'Conexão' } as const

/** The tabs of the sheet's form, with the API fields each one shows. */
export const EMPLOYEE_TAB_DEFS: ITabDef[] = [
  {
    key: 'personal',
    label: 'Dados pessoais',
    fields: [
      'name',
      'nickname',
      'email',
      'phone',
      'zip_code',
      'street',
      'number',
      'complement',
      'neighborhood',
      'city',
      'state',
      'bank_agency',
      'bank_account',
      'pix_key_type',
      'pix_key',
      'marital_status',
      'race',
      'has_children',
      'children_count',
      'photo'
    ]
  },
  {
    key: 'professional',
    label: 'Profissional',
    fields: ['job_position_id', 'sector_id', 'username', 'admission_date', 'termination_date']
  },
  { key: 'contacts', label: 'Contatos', fields: ['emergency_contacts'] },
  { key: 'benefits', label: 'Benefícios e VT', fields: ['transport_benefits', 'transport_routes'] }
]
